import Router from "./routes";
import ThemeProvider from "./theme";
import ThemeLocalization from "./locales";
import { StyledChart } from "./components/chart";
import SnackbarProvider from "./components/snackbar";
import { ThemeSettings } from "./components/settings";
import { MotionLazyContainer } from "./components/animate";
import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { setDeviceToken } from "redux/slices/notification.slice";
import { useNavigate } from "react-router";
import "./globalstyle.css";

function disableRightClick(e) {
  e.preventDefault();
}

function handleKeyDown(e) {
  if (
    (e.ctrlKey && e.shiftKey && e.code === "KeyI") ||
    (e.ctrlKey && e.shiftKey && e.code === "KeyJ")
  ) {
    e.preventDefault();
  }
}

export default function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getOnlySiteSettingLoader, getOnlySiteSettingData = [] } = useSelector(
    (state) => state.getOnlySiteSetting,
  );
  const { siteLogo, siteAuthorName, favicon, siteTitle } =
    getOnlySiteSettingData;

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== process.env.REACT_APP_VEDA_WEBSITE_URL) return;

      const { token, phoneNo, loginStatusOutside, userIdOutside } = event.data;
      if (!token) return;

      localStorage.setItem("token", token);
      localStorage.setItem("phoneNo", phoneNo);
      localStorage.setItem("loginStatusOutside", loginStatusOutside);
      localStorage.setItem("userIdOutside", userIdOutside);
      localStorage.setItem(
        "auth",
        JSON.stringify({ accessToken: token, userId: userIdOutside }),
      );

      dispatch(setDeviceToken(token));
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleBeforeUnload = (event) => {
    // event.preventDefault();
    // dispatch(
    //   addUserSpendTimeAsync({
    //     status: "close",
    //   })
    // );
    // sendCountMessage();
    // if (process.env.REACT_APP_RIGHT_CLICK === "true") {
    //   dispatch({ type: "LOGOUT" });
    // }
    // if (!event.currentTarget) {
    //   dispatch({ type: "LOGOUT" });
    // }
  };

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <ThemeLocalization>
            <SnackbarProvider>
              <StyledChart />
              <Helmet>
                <title>{siteTitle}</title>
                <link rel="icon" type="image/png" href={favicon} />
              </Helmet>
              <Router />
              <Toaster reverseOrder={false} />
            </SnackbarProvider>
          </ThemeLocalization>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
